<ng-container *ngIf="mobile">
	<app-mobile-user-device-registration>
	</app-mobile-user-device-registration>
</ng-container>
<ng-container *ngIf="!mobile">
	<app-web-user-device-registration>
	</app-web-user-device-registration>
</ng-container>
